import { Logo } from '@/components/common/Logo';
import { useI18n } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';

export default function BlockedScreen() {
  const { t } = useI18n();

  return (
    <div
      style={{
        backgroundColor: 'black',
        zIndex: 2147483647,
        display: 'flex',
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        width: '100vw',
        height: '100vh',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        transition: 'opacity 0.3s ease-in-out',
      }}
    >
      <div
        style={{
          transform: 'translateY(-27px)',
          display: 'flex',
          gap: '8px',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="flex flex-col items-center gap-2">
          <div className="w-19 h-19">
            <Logo />
          </div>
          <Typography size="3" textAlign="center">
            {t('blocked.description')}
          </Typography>
        </div>

      </div>
    </div>
  );
}